export default {
  hero_label: 'Company Overview',
  hero_title: '会社概要',
  hero_sub1: 'AIで日本の未来を切り拓く、',
  hero_sub2: '変革のパートナーとして。',
  scroll: 'SCROLL',
  section_mission: 'MISSION',
  mission_statement: 'AI領域における\nあらゆる課題を解決し、\n企業の持続的な成長を\n実現する',
  mission_desc: '私たちは、AIXコンサルティングの事業領域を通じて、企業が抱える課題をAIコンサルティングで包括的に解決します。単なるコンサルティングにとどまらず、実行支援まで一貫してサポートすることで、確実な成果創出を実現します。',
  vision_title: 'ビジョン',
  vision_desc: 'AI領域のプロフェッショナル集団として、日本企業の変革を牽引し、グローバル市場での競争力向上に貢献します。テクノロジーと人の力を融合させ、次世代のAI組織のあり方を創造していきます。',
  value_title: 'バリュー',
  value_1_title: '顧客第一主義',
  value_1_desc: 'お客様の成功を最優先に考え、長期的なパートナーシップを構築します',
  value_2_title: '実行力',
  value_2_desc: '戦略立案だけでなく、実行まで責任を持ってサポートします',
  value_3_title: '継続的な学習',
  value_3_desc: '常に最新の手法とテクノロジーを学び続けます',
  value_4_title: 'チームワーク',
  value_4_desc: '多様な専門性を持つメンバーが協力し、最高の価値を提供します',
  section_founding: 'FOUNDING STORY',
  founding_title: '設立の背景',
  founding_desc: '2025年1月、AIX JAPAN株式会社は「日本のビジネス現場にAIを本質的に根付かせる」という一つの確信のもとに設立されました。急速に進化するAI技術の波は、多くの企業にとって脅威ではなく、大きなチャンスです。しかし、その恩恵を享受できているのはまだ一部にすぎません。私たちは、このギャップを埋めることを使命として、東京の地からスタートを切りました。',
  founder_quote: '「AIは道具ではなく、組織の新しいチームメンバーになる。その変革を、私たちが最前線で伴走します。」',
  founder_name: '代表取締役 — 鈴木 章史',
  pillar_1_title: '課題の発見',
  pillar_1_body: '日本企業の現場で「AI活用の必要性は理解しているが、どこから手をつけるべきかわからない」という声が絶えないことに気づきました。',
  pillar_2_title: '橋渡しの役割',
  pillar_2_body: '最先端のAI技術と実際のビジネス現場をつなぐ専門家集団が不在である。この「橋渡し」こそ私たちが担うべき役割だと確信しました。',
  pillar_3_title: '人材の育成',
  pillar_3_body: '技術導入だけでは変革は続きません。組織に根付くAI人材を育て、自走できる企業をつくることを創業の柱に据えています。',
  section_info: 'COMPANY INFORMATION',
  access_title: 'アクセス',
  map_link: 'Google Mapで見る',
  info_company_name: '会社名',
  info_company_name_en: '英文社名',
  info_founded: '設立',
  info_ceo: '代表取締役',
  info_capital: '資本金',
  info_address: '所在地',
  info_email: 'メールアドレス',
  info_business: '事業内容',
  info_company_name_value: 'AIX JAPAN株式会社',
  info_company_name_en_value: 'AIX JAPAN Co., Ltd.',
  info_founded_value: '2025年1月23日',
  info_ceo_value: '鈴木 章史',
  info_capital_value: '5,000,000円',
  info_address_value: '〒160-0023\n東京都新宿区西新宿3-2-9\n新宿ワシントンホテルビル本館 2F',
  info_business_value: '◉AIX事業\nAIX コンサルティング\nAIX マネージャー\nAIX トレーニング\nAIエージェント開発\n\n◉事業開発\n戦略コンサルティング\n新規事業開発コンサルティング\n\n◉IT関連\nITコンサルティング\nシステム開発\nインフラ設計構築\n運用保守\n品質管理\nセキュリティ\n\n◉自社サービス\n生成AI All In One Toolの企画・開発・運営',
  access_route_1: 'JR新宿駅南口から　徒歩約8分',
  access_route_2: '都営大江戸線 都庁前駅　徒歩約5分',
};